import { render, staticRenderFns } from "./HistoricalCardTable.vue?vue&type=template&id=deb7f0c4&"
import script from "./HistoricalCardTable.vue?vue&type=script&lang=js&"
export * from "./HistoricalCardTable.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalCardTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports